import Image from 'next/image';

const validImageExtensions = /\.(gif|jpe?g|tiff?|png|webp|svg|bmp)$/i;

const ImageWithFallback = (props: { [x: string]: any; src: any; alt: any }) => {
  const { src, alt, ...rest } = props;

  const broken =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8z8AAPAOBArUqDRgAAAAASUVORK5CYII=';

  const ckImg = validImageExtensions.test(src) ? src.replace(process.env.CDN_URL, '/cdn') : broken;

  return (
    <Image
      alt={alt}
      src={src}
      key={src}
      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
      decoding="async"
      loading={rest.loading ? 'lazy' : rest.loading}
      {...rest}
    />
  );
};

export default ImageWithFallback;
